import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import { Col, Row } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';
import { Button } from 'components/atoms/button';
import { SingleValue, Option } from 'components/atoms/select';
import { SalesforceResourceMappingLocalData } from '../../types';
import { PopoverSelect } from '../commons';

const BasePlaceholderStyles = css`
  color: var(--blue-60);
  opacity: 0.5;
  pointer-events: none;
`;

const SyncPlaceholder = styled(ArrowRight16)`
  ${BasePlaceholderStyles};
`;

const NativeFieldPlaceholder = styled(Button)`
  ${BasePlaceholderStyles};
  padding: auto 0px;
`;

type EmptyStateProps = {
  fields: Option<boolean>[];
  onChange: (value: SingleValue<boolean>) => void;
  fieldObject: SalesforceResourceMappingLocalData;
};

export const EmptyState = ({
  fields,
  onChange,
  fieldObject,
}: EmptyStateProps) => {
  return (
    <Row align="middle">
      <Col flex="375px">
        <PopoverSelect
          options={fields}
          onChange={onChange}
          type="salesforce"
          fieldObject={fieldObject}
        />
      </Col>
      <Col flex="36px">
        <SyncPlaceholder />
      </Col>
      <Col flex="408px">
        <NativeFieldPlaceholder type="text" disabled>
          <FormattedMessage id="settings.integrations.sf.resource_mappings.rocketlane.trigger" />
        </NativeFieldPlaceholder>
      </Col>
    </Row>
  );
};
